/* Globals required for processing JSON Tabular data */
export const DATA_UPDATED = 'DATA_UPDATED';
export const NUMBER_OF_OUTAGES = 'NUMBER_OF_OUTAGES';
export const CUSTOMERS_AFFECTED = 'CUSTOMERS_AFFECTED';
export const CUSTOMERS_SERVED = 'CUSTOMERS_SERVED';
export const CUSTOMERS_RESTORED = 'CUSTOMERS_RESTORED';
